import { createAction, props } from '@ngrx/store';

import { PageId } from './size.state';

export namespace SizeActions {
  export const SetPageSizes = createAction(
    '[Size] Set Page Sizes',
    props<{ pageId: PageId; sizes: Record<string, string> }>()
  );
}
